var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"id":"additional-info"}},[_c('v-flex',[_c('blw-sections',{staticClass:"mb-3",attrs:{"contents":_vm.sections,"squareCheckBox":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }